module.exports = __webpack_public_path__ + "media/tone-end-small.3200a7d7.wav";